import React from 'react';

import {
  getPersonalDataItems,
  TemplateSection,
} from '@xing-com/crate-lebenslauf-components';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

export const usePersonalData = (): JSX.Element[] => {
  const [data, setData] = React.useState<JSX.Element[]>([]);
  const { cv } = useReadVitaReactiveVariable();

  React.useEffect(() => {
    const personalData = cv?.personalInformation;
    const items = personalData ? getPersonalDataItems(personalData) : [];

    setData(
      items.length
        ? [
            <div key="name">
              <TemplateSection name="personalInformation" />
              {items[0]}
            </div>,
            ...items.slice(1),
          ]
        : []
    );
  }, [cv?.personalInformation]);

  return data;
};
